export interface IAuthorities {
  id?: number;
  name?: string | null;
  title?: string | null;
}

export const defaultValue: Readonly<IAuthorities> = {};
